const enum NotificationTypeEnum {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  info = 'info',
  light = 'light',
}

export default NotificationTypeEnum;
